import { yup } from '@guiker/yup-util'

export const getLeaseDownloadLinkByScopeQueryParams = yup.object({
  locale: yup.string().optional(),
})

export type GetLeaseDownloadLinkByScopeQueryParams = yup.InferType<typeof getLeaseDownloadLinkByScopeQueryParams>
